import { AvailabilityExtras } from './../../../../services/local-storage.service';
import { GetSectorAvailabilityOptions } from './../../../../services/travel.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Availability, ProductUrl } from '../../../../models/availability.model';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { ActionUpdaterService, ApiError } from '../../../../services/action-updater.service';
import { SlickSliderComponent } from '../../../slick-slider/slick-slider.component';
import { RunningDogModalComponent } from '../../../running-dog-modal/running-dog-modal.component';
import * as moment from 'moment';
import { ProductTypeUrl } from 'app/shared/models/enums/ProductTypeUrl.enum';
import { ITINERARY_CONTEXT } from '../../../../models/enums/context.enum';
import { TravelOptions } from 'app/shared/models/timetables.model';
import { TravelService } from 'app/shared/services/travel.service';
import { InitialDataService } from 'app/initial-data.service';
import { EventBusService } from 'app/shared/services/event-bus.service';
import { ModalDirective } from 'ngx-bootstrap';
import { ModalPopupMainPageEvent } from 'app/shared/models/app-events-types.model';
import { ModalPopupMainPageEventWrapper } from 'app/shared/models/app-events.model';
@Component({
    selector: 'gaweb-availability-wrapper',
    templateUrl: './availability-wrapper.component.html'
})
export class AvailabilityWrapperComponent implements OnInit {
    @ViewChild(SlickSliderComponent) slickSliderComponent; // First
    @ViewChild(RunningDogModalComponent) runningDogModalComponent; // First
    @ViewChild('NextAvailableTripModal') public childModal: ModalDirective;

    isAvailabilityPartOfReturnBooking: boolean;
    bookingGuid: string;
    currentAvailability: Array<Availability>;
    availabilityGuid: string;
    productReference: string;
    currentSlide = 0;
    ProductTypeUrl = ProductTypeUrl;
    context: ITINERARY_CONTEXT;
    targetSector: number; // When we're changing a specific sector on a booking. (Eg. Flexi fare on express)
    isTimeTables: boolean;
    productUrl: ProductUrl;
    productTypeUrl: ProductTypeUrl;
    
    public config = {
        animated: true,
        keyboard: true,
        backdrop: false,
        ignoreBackdropClick: false
    };
    constructor(private router: Router,
        private actionUpdaterService: ActionUpdaterService,
        private activatedRoute: ActivatedRoute,
        private localStorageService: LocalStorageService,
        private initialDataService: InitialDataService,
        private travelService: TravelService,
        private eventBusService: EventBusService
    ) {

        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            if (evt.urlAfterRedirects.indexOf('add=true') === -1) {
                window.scrollTo(0, 0);
            }

        });
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe(
            (params: any) => {
                this.isTimeTables = params['context'] === 'timetables';
                this.productReference = params['product-reference'];
            });
        this.activatedRoute.queryParams.subscribe(
            (params: any) => {
                const comesFromMyGreyhound = Number.parseInt(params['context']) === ITINERARY_CONTEXT.MY_GREYHOUND;
                this.context = Number.parseInt(params['context']);
                this.isTimeTables = params['context'] === 'timetables';
                this.productUrl = new ProductUrl(this.router.url, this.initialDataService);
                this.productTypeUrl = this.productUrl.ProductTypeUrl;
                this.productUrl.isManageBooking = comesFromMyGreyhound;
            });
        this.currentAvailability = this.localStorageService.currentAvailability;
        if (!this.currentAvailability) {
            this.currentAvailability = this.localStorageService.getTravelAvailability();
        }
        if (!this.localStorageService.currentAvailabilityOptions) {
            const travelOptions: TravelOptions = this.localStorageService.getTravelOptions();
            if (!!travelOptions) {
                this.localStorageService.currentAvailabilityOptions = travelOptions.options;
            }
        }
        if (!!this.localStorageService.currentAvailabilityOptions) {
            this.currentSlide = this.localStorageService.currentAvailabilityOptions.currentSlide;
            this.isAvailabilityPartOfReturnBooking = !!this.localStorageService.currentAvailabilityOptions.isReturn;
        }
        const availabilityExtras = this.localStorageService.getAvailabilityExtras();
        if (!!availabilityExtras) {
            this.bookingGuid = availabilityExtras.bookingGuid;
            this.productReference = availabilityExtras.productReference;
            this.isAvailabilityPartOfReturnBooking = availabilityExtras.isReturn;
            this.context = !!availabilityExtras.context ? availabilityExtras.context : this.context;
            this.targetSector = availabilityExtras.sector;
        }

        if (!!this.currentAvailability && !!this.currentAvailability.length) {
            this.availabilityGuid = this.currentAvailability[0].TravelGUID;
        } else {
            this.handleMissingAvailability();
        }
        this.populateUrl();
    }

    private populateUrl() {
        window.history.pushState(null, null, "book-a-ticket/availability?origin=" + this.currentAvailability[0].OriginStopCode + "&destination="  + this.currentAvailability[0].DestinationStopCode);
    }

    ngAfterViewInit() {
        if (this.currentAvailability[0].SelectedDate !== this.currentAvailability[0].TravelDate) {
            this.showModal();
        }

    }


    // Will not support refresh if there is no availability guid ( api is suggesting new date via NextAvailabilityDate)
    // or we refresh in the outbound leg of a return trip
    //  *** This is because ****
    // In the event where there is no availability returned for the outgoing trip but suggestions are made (NextAvailabilityDate etc)
    // there will only be one item in the availability array even with an return=true availability call hence no ReturnGuid and need
    // for extra check
    private handleMissingAvailability() {
        this.currentAvailability = [] as Array<Availability>;

        if (!this.availabilityGuid || (this.currentSlide === 0 && this.isAvailabilityPartOfReturnBooking)) {
            const back = this.getBackUrl();
            this.router.navigate([back.urlWithoutQueryString], {
                queryParams: back.queryParams
            });
            return;
        }
        this.travelService.getAvailabilityViaTravelGuid(this.availabilityGuid).subscribe(
            (a1: Availability) => {
                const tempAvailability = [a1];
                this.updateAvailability(tempAvailability, null);
            }, this.actionUpdaterService.onError)
    }

    private updateAvailability(availability: Array<Availability>, applyAfterRefresh?: () => void) {
        this.currentAvailability = availability;
        this.localStorageService.currentAvailability = availability;
        this.localStorageService.saveTravelAvailability(availability);
        if (!!this.slickSliderComponent) {
            const that = this;
            setTimeout(function () {
                that.slickSliderComponent.hide();
                that.slickSliderComponent.refresh();
                if (!!applyAfterRefresh) {
                    applyAfterRefresh();
                }

                setTimeout(function () {
                    that.slickSliderComponent.show();
                    that.runningDogModalComponent.hideModal();
                }, 500);
            }, 0);
        }

        if (this.currentAvailability[0].SelectedDate !== this.currentAvailability[0].TravelDate) {
            this.showModal();
        }
    }

    private getBackUrl(): BackUrlPage {
        let back = null;
        if (this.productUrl.isManageBooking) {
            // TODO change to use from initial data service
            back = new BackUrlPage('/my-greyhound/booking-management/details');
            back.queryParams = { bookingGuid: this.bookingGuid, addTravel: true };
        } else if (this.productUrl.ProductTypeUrl === ProductTypeUrl.package) {
            // tslint:disable-next-line:max-line-length
            var productRef = window.location.pathname.split('/')[1];
            const categoryReference = this.activatedRoute.snapshot.params['category-reference'];
            const productReference = this.activatedRoute.snapshot.params['product-reference'];

            back = new BackUrlPage(`/${productRef}/${categoryReference}/${productReference}/book-now/${this.bookingGuid}?removeTravel=true`);
        } else if (this.productUrl.ProductTypeUrl === ProductTypeUrl.expressBooking) {
            if (this.isTimeTables) {
                back = new BackUrlPage('/information/timetables');
            } else {
                back = new BackUrlPage('/book-a-trip');
            }
        }
        return back;
    }

    onRefreshAvailabilityByDate($event: RefreshAvailabilityByDateOption) {
        const options = this.localStorageService.currentAvailabilityOptions,
            isRefreshingReturnAvailability = () => $event.availabilityIndex === 1;
        const applyAfterRefresh = () => {
            if (isRefreshingReturnAvailability()) {
                this.slickSliderComponent.slickNext();
            }
        };

        if (this.productUrl.isManageBooking && this.productTypeUrl !== ProductTypeUrl.travelPasses) {
            const availabilityExtras: AvailabilityExtras = this.localStorageService.getAvailabilityExtras();
            const getSectorAvailabilityOptions = new GetSectorAvailabilityOptions(this.bookingGuid, availabilityExtras.sector, $event.date);
            this.runningDogModalComponent.showModal();
            this.travelService.getSectorAvailability(getSectorAvailabilityOptions).subscribe((availability: Availability[]) => {
                this.updateAvailability(availability, applyAfterRefresh);
            }, this.onError);
            return;
        }
        // TODO bootstrap this options object from the availability but for now going back to main page
        if (!this.localStorageService.currentAvailabilityOptions) {
            const back = this.getBackUrl();
            this.router.navigate([back.urlWithoutQueryString], {
                queryParams: back.queryParams
            });
            return;
        }

        options.TravelLegs[$event.availabilityIndex].travelDate = $event.date;
        if ($event.availabilityIndex === 0 && options.TravelLegs.length === 2) {
            const departureDate = moment(options.TravelLegs[0].travelDate);
            const returnDate = moment(options.TravelLegs[1].travelDate);
            if (departureDate.isAfter(returnDate)) {
                // return date will be the same as the departure
                options.TravelLegs[1].travelDate = departureDate.format('YYYY-MM-DD');
            }
        }
        this.runningDogModalComponent.showModal();
        // new express booking availability - not for existing booking (my greyhound)
        this.travelService.getAvailability(options).subscribe(
            (availability: Array<Availability>) => {
                this.updateAvailability(availability, applyAfterRefresh);
            }, this.onError
        );
    }
    onHandleChooseFare() {
        this.runningDogModalComponent.showModal();
    }
    onError = (error) => {
        this.runningDogModalComponent.hideModal();
        this.actionUpdaterService.onError(error);
    }

    goToPreviousSlide() {
        if (this.currentSlide > 0) {
            this.slickSliderComponent.slickPrev();
            this.currentSlide -= 1;
            return;
        }

        this.currentSlide = 0;
        const back = this.getBackUrl();
        window.location.href = back.url;

    }

    onMoveToReturnSlide() {
        this.slickSliderComponent.slickNext();
        this.currentSlide = 1;
    }

    showModal() {
        this.childModal.show();
        const ev = new ModalPopupMainPageEvent(true);
        this.eventBusService.emit(new ModalPopupMainPageEventWrapper(ev));
    }

    hideModal() {
        this.childModal.hide();
        const ev = new ModalPopupMainPageEvent(false);
        this.eventBusService.emit(new ModalPopupMainPageEventWrapper(ev));
    }
}

export class RefreshAvailabilityByDateOption {
    constructor(public date: string, public availabilityIndex: number) { }
}
class BackUrlPage {
    public get url(): string {
        if (!this.queryParams) {
            return this.urlWithoutQueryString;
        }
        const fullUrl = [];
        for (const p in this.queryParams) {
            if (this.queryParams.hasOwnProperty(p)) {
                fullUrl.push(encodeURIComponent(p) + '=' + encodeURIComponent(this.queryParams[p]));
            }

        }
        return this.urlWithoutQueryString + '?' + fullUrl.join('&');
    }
    public queryParams: object;
    constructor(public urlWithoutQueryString: string) {

    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/itinerary/travel-dates/availability-wrapper/availability-wrapper.component.ts